import React from 'react'

function CalltoAction() {
  return (
    <>
      

        <section id="call-to-action" className="call-to-action section dark-background">
        <img src="/assets/img/cta-bg.jpg" alt="" />
        <div className="container">
          <div className="row" data-aos="zoom-in" data-aos-delay={100}>
            <div className="col-xl-9 text-center text-xl-start">
              <h3>Call To Action</h3>
              <p>Partner with Al Mac Company — where quality meets reliability.</p>
              <p>Contact us today to learn more about our services and how we can help you succeed.</p>
              <p>
                📞 Call Now:&nbsp;
                <a href="tel:+966502022626">+966 50 20 22 626</a> / 
                <a href="tel:+966559534007">+966 55 95 34 007</a>
              </p>
              <p>
              📧 Email Us:&nbsp;
              <a href="mailto:almaccompany@gmail.com">almaccompany@gmail.com</a> / 
              <a href="mailto:build@almaccompany.com">build@almaccompany.com</a>
            </p>

              <p>Let’s build something great together</p>
            </div>
            <div className="col-xl-3 cta-btn-container text-center">
              <a className="cta-btn align-middle" href="#">Call To Action</a>
              {/* <a href="tel:8157973633" target="_blank" rel="noopener noreferrer" style={{alignItems:'center'}}></a> */}
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default CalltoAction



      